<script>
  import { productStore } from '@/lib/productStore.js';
  import { emitter } from '@/main.js';
  import { cleanName, handleize, isTrimmed, handleViewportSize } from '@/lib/vue-helpers.js';
  import { fetchSizeGuidePageContent } from '@/lib/sizeGuide.js';
  import { setUniformSwatchWidths } from '@/lib/swatchWidths.js';
  import storefront from '@/lib/storefront';
  import * as queries from '@/lib/queries';
  import VueCookies from 'vue-cookies';

  export default {
    name: 'SizeVariantOption',
    computed: {
      cleanSizeName() {
        return name => cleanName(name);
      }
    },
    data() {
      return {
        colors: [],
        product_title: '',
        sizes: [],
        selectedColor: '',
        selectedSize: '',
        selectedWidth: '',
        isSizeSelected: false,
        optionTwoName: '',
        isLoading: true,
        sizeGuideMetafield: '',
        helpGuideMetafield: '',
        isOutfitPicker: false,
        mini_pdp: false,
        isMobileViewport: false,
        excludeSwatchWidth: false,
        optiontwoorder: [],
        optiontwoorderoverride: [],
        optiontwoorderoverridetag: '',
        passedOptTwo: '',
        pdpSection: null,
        previouslySelectedSize: '',
        product_handle: '',
        userPreferredProductSize: '',
        show_image_2: '',
        comingSoonTag: window.siteGlobals.set_reminder_tag,
        variants: [],
        slideVariantImageTags: '',
        slideVariantImage: false,
        lastEmittedImage: null,
        imageNS: null,
        imageKey: null,
        imageNS2: null,
        imageKey2: null,
        vimageNS: null,
        vimageKey: null,
        outfitPickerIndex: null,
        ShowSizeGuideButton: false,
        ShowHelpGuideButton: false,
        helpGuidePageTitle: '',
        isBundleProduct: false,
        bundledProducts: [],
        activeBundleHandle: null,
        selectedBundledProductIndex: 0,
        originalProductData: null,
        isHiddenForBundle: false
      };
    },
    mounted() {
      this.handleViewportSize = handleViewportSize(this);
      this.sizeGuideMetafield = window.sizeGuideMetafield;
      this.helpGuideMetafield = window.helpGuideMetafield;
      this.product_title = this.$el.parentElement.getAttribute('data-product-name');
      this.product_handle = this.$el.parentElement.getAttribute('data-product-handle');
      this.imageLookUpMax = parseInt(this.$el.parentElement.getAttribute('data-imageLookUpMax'));
      this.mini_pdp = this.$el.parentElement.getAttribute('data-mini-pdp') === 'true';
      this.isOutfitPicker = this.$el.parentElement.getAttribute('data-is-outfit-picker') === 'true';
      this.excludeSwatchWidth = window.excludeSwatchWidth === 'true';
      this.optiontwoorder = this.$el.parentElement.getAttribute('data-optiontwoorder')?.split(',') || [];
      this.optiontwoorderoverride = this.$el.parentElement.getAttribute('data-optiontwoorderoverride')?.split(',') || [];
      this.optiontwoorderoverridetag = this.$el.parentElement.getAttribute('data-optiontwoorderoverridetag');
      this.show_image_2 = this.$el.parentElement.getAttribute('data-show-image-2') === 'true';
      this.pdpSection = this.$el.parentElement.closest('.product-single') || this.$el.parentElement.closest('.mini-product-single');
      this.slideVariantImageTags = this.$el.parentElement.getAttribute('data-slide-variant-image-tags') || '';
      this.slideVariantImage = this.$el.parentElement.getAttribute('data-slideVariantImage') === 'true';
      if (!this.slideVariantImage && this.pdpSection) {
        const widthBlock = this.pdpSection.querySelector('[data-slide-variant-image]');
        if (widthBlock && widthBlock.getAttribute('data-slide-variant-image') === 'true') {
          this.slideVariantImage = true;
        }
      }

      if (this.isOutfitPicker) {
        this.pdpSection = this.$el.parentElement;
      }

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      this.passedOptTwo = urlParams.get('op2');
      this.userPreferredProductSize = VueCookies.get('pdp-size');

      emitter.on('product-data-updated', this.handleProductData);
      emitter.on('plytix-product-data-ready', this.handlePlytixData);
      emitter.on('variant-color-selected', ({ color }) => {
        if (this.isOutfitPicker) return;
        this.selectedColor = color;
        this.updateAvailability();
        this.shouldHideSizes();
        this.$nextTick(() => this.setOptionTwoWidth());
      });
      emitter.on('pdp-cookie-updated', ({ type, value }) => {
        if (type === 'size') {
          this.userPreferredProductSize = value;
        }
      });
      emitter.on('variant-width-selected', ({ width }) => {
        if (this.isOutfitPicker) return;
        this.selectedWidth = width;
        this.updateAvailability();
        this.shouldHideSizes();
        this.$nextTick(() => this.setOptionTwoWidth());
      });
      emitter.on('bundled-product-selected', this.handleBundledProductSelected);

      const hasPlytixData = this.checkPlytixData();
      if (!hasPlytixData) {
        this.initializeData();
      }
      this.closeSizeGuideModal();
      this.updateMobileViewport();

      if (this.isOutfitPicker) {
        this.$nextTick(() => {
          this.resolveOutfitPickerIndex();
          this.getSizeGuideData();
        });
        emitter.on('outfit-picker-product-changed', this.handleOutfitPickerProductChanged);
        emitter.on('outfit-picker-width-changed', ({ blockIndex, width }) => {
          if (!this.outfitPickerIndex) this.resolveOutfitPickerIndex();
          if (this.outfitPickerIndex !== blockIndex) return;
          this.selectedWidth = width;
          this.updateAvailability();
          this.shouldHideSizes();
          this.$nextTick(() => this.setOptionTwoWidth());
        });
      }
      document.addEventListener('theme:resize:width', this.handleSwatchResize);
      this.getSizeGuideData();
      this.getHelpGuideData();
    },
    beforeUnmount() {
      if (this.handleViewportSize) this.handleViewportSize();
      emitter.off('product-data-updated', this.handleProductData);
      emitter.off('plytix-product-data-ready', this.handlePlytixData);
      emitter.off('variant-color-selected');
      emitter.off('pdp-cookie-updated');
      emitter.off('variant-width-selected');
      emitter.off('bundled-product-selected');
      if (this.isOutfitPicker) {
        emitter.off('outfit-picker-product-changed', this.handleOutfitPickerProductChanged);
        emitter.off('outfit-picker-width-changed');
      }
      document.removeEventListener('theme:resize:width', this.handleSwatchResize);
    },
    methods: {
      sizeOptionAriaLabel(sizeAttr, available) {
        const size = sizeAttr?.startsWith('s') ? sizeAttr.slice(1) : (sizeAttr || '').trim();
        const colorContext = this.selectedColor ? ` in color ${this.selectedColor}` : '';
        const status = available ? 'available' : 'currently unavailable';
        return `${this.product_title}${colorContext} size option: ${size} is ${status}`;
      },
      shouldShowSizeGuideButton(show) {
        if (this.sizeGuideMetafield && show) {
          this.ShowSizeGuideButton = true;
        } else {
          this.ShowSizeGuideButton = false;
        }
      },
      shouldShowHelpGuideButton(show) {
        if (this.helpGuideMetafield && show) {
          this.ShowHelpGuideButton = true;
        } else {
          this.ShowHelpGuideButton = false;
        }
      },
      normalizeSmartTags(tagsString) {
        return (tagsString || '')
          .split(',')
          .map(tag => tag.trim().toLowerCase())
          .filter(Boolean);
      },
      shouldEnableSmartTagsFromPlytixTags(tags) {
        const smartTags = this.normalizeSmartTags(this.slideVariantImageTags);
        if (!smartTags.length || !Array.isArray(tags)) return null;
        const normalizedTags = tags.map(tag => (tag || '').toString().trim().toLowerCase());
        return smartTags.some(tag => normalizedTags.includes(tag));
      },
      applySmartTagsFromPlytix(data) {
        const currentTags = data?.colors?.[0]?.tags;
        const enabled = this.shouldEnableSmartTagsFromPlytixTags(data?.colors?.[0]?.tags);
        const loggingEnabled = productStore.isLoggingEnabled(document.getElementById('product-families-json-data')?.dataset.speedTracking === 'true');
        if (enabled === null) {
          if (loggingEnabled) console.log('[SmartTags][Size] Fallback to Liquid boolean', { productTitle: this.product_title, slideVariantImage: this.slideVariantImage, smartTags: this.slideVariantImageTags, plytixTags: currentTags });
          return;
        }
        this.slideVariantImage = enabled;
        if (loggingEnabled) console.log('[SmartTags][Size] Plytix tag match', { productTitle: this.product_title, enabled, smartTags: this.slideVariantImageTags, plytixTags: currentTags });
      },
      async initializeData() {
        try {
          await productStore.fetchProductData(this.product_title, window.Shopify.country, this.imageLookUpMax, parseInt(window.siteGlobals.pdp_productsByTitleLookup), this.imageNS, this.imageKey, this.imageNS2, this.imageKey2, this.vimageNS, this.vimageKey, null, null, this.product_handle);
        } catch (err) {
          console.error('PDP size data fetch failed:', err);
        } finally {
          this.handleContentLoaded();
        }
      },
      handleProductData(data) {
        if (!data || !Array.isArray(data.sizes)) return;
        if ((this.isOutfitPicker && data.productHandle && data.productHandle !== this.product_handle) || (data.productTitle && data.productTitle !== this.product_title)) {
          return;
        }

        this.originalProductData = data;
        this.isBundleProduct = Boolean(data.isBundleProduct);
        this.bundledProducts = data.bundledProducts || [];
        this.activeBundleHandle = data.activeBundleHandle || (this.isBundleProduct && this.bundledProducts.length ? this.bundledProducts[0].handle : this.product_handle);

        if (this.isBundleProduct) {
          this.hideSizeModule();
          return;
        }

        this.applyProductData(data);
      },
      hideSizeModule() {
        if (this.isHiddenForBundle) return;
        this.isHiddenForBundle = true;
        if (this.$el && this.$el.style) {
          this.$el.style.display = 'none';
        }
      },
      handleBundledProductSelected() {
        if (!this.isBundleProduct) {
          return;
        }
        this.hideSizeModule();
      },
      applyProductData(productData) {
        if (!productData) return;
        this.applySmartTagsFromPlytix(productData);
        this.colors = productData.colors || [];
        this.sizes = this.sortOptionTwoData(productData.sizes || [], productData.colors?.[0]?.tags);
        this.optionTwoName = productData.optionTwoName;
        this.variants = productData.variants || [];
        this.isLoading = true;
        this.selectedSize = '';
        this.isSizeSelected = false;

        const delay = this.isOutfitPicker ? 0 : 300;
        setTimeout(() => {
          this.setDefaultSelections();
          this.isLoading = false;
          this.$nextTick(() => {
            this.setOptionTwoWidth();
            this.updateAvailability();
            if (this.selectedSize && Array.isArray(this.sizes) && this.sizes.includes(this.selectedSize)) {
              this.setSizeSelection(this.selectedSize);
            }
            this.shouldHideSizes();
          });
        }, delay);
      },
      setOptionTwoWidth() {
        if (!this.$el?.querySelectorAll) return;
        const optionButtons = this.$el.querySelectorAll('.variant-spacing.option-size-2 .p-options');
        setUniformSwatchWidths(optionButtons, this.excludeSwatchWidth);
      },
      handleSwatchResize() {
        this.updateMobileViewport();
        this.$nextTick(() => this.setOptionTwoWidth());
      },
      handleOutfitPickerProductChanged({ blockIndex, productTitle, productHandle }) {
        if (!this.isOutfitPicker) return;
        if (!this.outfitPickerIndex) this.resolveOutfitPickerIndex();
        if (this.outfitPickerIndex !== blockIndex) return;
        if (!productTitle) return;
        this.product_title = productTitle;
        this.product_handle = productHandle || '';
        this.selectedSize = this.previouslySelectedSize || '';
        this.isSizeSelected = !!this.selectedSize;
        if (!this.isLoading) {
          this.isLoading = true;
        }
        this.initializeData();
        this.getSizeGuideData();
        this.getHelpGuideData();
      },
      setSizeSelection(size) {
        if (isTrimmed(size.toString())) {
          size = size.toString();
        } else {
          size = size.trim();
        }

        this.selectedSize = size;
        this.isSizeSelected = true;

        [...this.pdpSection.querySelectorAll('[data-size]')].forEach(el => {
          el.classList.remove('selected');
        });

        const sizeElements = this.pdpSection.querySelectorAll(`[data-size='s${CSS.escape(size)}']`);
        sizeElements.forEach(el => {
          el.classList.add('selected');
        });

        const hasAvailableVariant = this.variants.some(v => v.availableForSale && v.size === size && v.color === this.selectedColor);

        if (hasAvailableVariant) {
          VueCookies.set('pdp-size', size);
          emitter.emit('pdp-cookie-updated', { type: 'size', value: size });
        }

        this.previouslySelectedSize = size;

        emitter.emit('variant-size-selected', { size });

        if (this.isOutfitPicker) {
          if (!this.outfitPickerIndex) {
            this.resolveOutfitPickerIndex();
          }
          emitter.emit('outfit-picker-size-changed', {
            blockIndex: this.outfitPickerIndex,
            size
          });
        }

        this.updateAvailability();
        this.shouldHideSizes();
        this.handleSlideVariantImage(size);
      },
      updateAvailability() {
        let colorToUse = this.selectedColor;
        try {
          const selectedColorEl = this.pdpSection?.querySelector('.color-variant-options [data-color].selected');
          if (selectedColorEl) {
            colorToUse = selectedColorEl.getAttribute('data-color') || '';
          }
        } catch (e) {
          console.warn('Failed to resolve selected color for size options', e);
        }
        if (!colorToUse && Array.isArray(this.colors) && this.colors.length) {
          const byHandle = this.product_handle ? this.colors.find(c => c.handle === this.product_handle) : null;
          colorToUse = (byHandle && byHandle.name) || this.colors[0].name || '';
        }

        let widthToUse = this.selectedWidth;
        try {
          const selectedWidthEl = this.pdpSection?.querySelector('.width-variant-options [data-width].selected');
          if (selectedWidthEl) {
            const raw = selectedWidthEl.getAttribute('data-width') || '';
            widthToUse = raw.startsWith('w') ? raw.slice(1) : raw;
          }
        } catch (e) {
          console.warn('Failed to resolve selected width for size options', e);
        }

        if (!colorToUse) return;

        const variants = this.variants || [];

        if (widthToUse) {
          const hasWidthForColor = variants.some(v => v && v.color === colorToUse && (!v.width || v.width === widthToUse));
          if (!hasWidthForColor) widthToUse = '';
        }

        const avilableSizes = variants.filter(v => v && v.availableForSale && v.color === colorToUse && (!widthToUse || !v.width || v.width === widthToUse) && v.size);
        let enabledSizes = new Set(avilableSizes.map(v => v.size));

        if (enabledSizes.size === 0 && !widthToUse) {
          enabledSizes = new Set(variants.filter(v => v && v.availableForSale && v.color === colorToUse && v.size).map(v => v.size));
        }

        this.disableAllOptions();
        enabledSizes.forEach(s => this.setEnabled(s));
      },
      disableAllOptions() {
        [...this.pdpSection.querySelectorAll('[data-size]')].forEach(el => {
          el.classList.add('unavailable');
          el.setAttribute('aria-label', this.sizeOptionAriaLabel(el.getAttribute('data-size'), false));
        });
      },
      setEnabled(size) {
        [...this.$el.parentElement.querySelectorAll(`[data-size='s${CSS.escape(size)}']`)].forEach(el => {
          el.classList.remove('unavailable');
          el.setAttribute('aria-label', this.sizeOptionAriaLabel(el.getAttribute('data-size'), true));
        });
      },
      sortOptionTwoData(passed, tags) {
        if (!Array.isArray(passed)) return [];
        let sortingArr = this.optiontwoorder;
        if (tags) {
          if (tags.includes(this.optiontwoorderoverridetag)) {
            sortingArr = this.optiontwoorderoverride;
          }
        }
        sortingArr = Array.isArray(sortingArr) ? sortingArr : [];
        if (!passed.length) return [];
        return passed.sort((a, b) => sortingArr.indexOf(a) - sortingArr.indexOf(b));
      },
      checkPlytixData() {
        if (window.productFamiliesData && Array.isArray(window.productFamiliesData) && window.productFamiliesData.length > 0) {
          const preloadedData = productStore.getPreloadedProductData(this.product_title);
          if (preloadedData && preloadedData.length > 0) {
            productStore.processAndEmitData(preloadedData, this.product_title);
            this.handleContentLoaded();
            return true;
          }
        }
        return false;
      },
      handlePlytixData(processedData) {
        if (processedData && Array.isArray(processedData) && processedData.length > 0) {
          const preloadedData = productStore.getPreloadedProductData(this.product_title);
          if (preloadedData && preloadedData.length > 0) {
            productStore.processAndEmitData(preloadedData, this.product_title);
            this.handleContentLoaded();
          }
        }
      },
      handleContentLoaded() {
        const container = this.$el.parentElement.closest('.pdp-size-variant-options-container');
        if (!container) return;
        const loader = container.querySelector('.pdp-variant-loader');
        if (!loader) return;
        loader.style.minHeight = '0';
        loader.style.opacity = '0';
        loader.style.visibility = 'hidden';
        loader.style.transition = 'opacity 0.2s ease-out, visibility 0.2s ease-out, height 0.2s ease-out, margin 0.2s ease-out';

        setTimeout(() => {
          loader.style.display = 'none';
          loader.style.height = '';
          loader.style.margin = '';
          loader.style.overflow = '';
          loader.style.pointerEvents = '';
        }, 200);
      },
      async getMetafields(metaIdentifier) {
        try {
          const response = await storefront.request(queries.metafieldsByProductHandle, {
            variables: {
              handle: this.product_handle,
              countryIso2: window.Shopify.country,
              metaIdentifier: metaIdentifier
            }
          });
          if (response && response.data?.product?.metafields) {
            return response.data.product.metafields;
          }
        } catch (error) {
          console.error('Error fetching size guide metafields:', error);
          return null;
        }
      },
      async getOnlineStorePage(pageId) {
        try {
          const response = await storefront.request(queries.getOnlineStorePageById, {
            variables: {
              id: `gid://shopify/Page/${pageId}`
            }
          });
          if (response && response.data.page) {
            const page = response.data.page;
            // reconstruct full page as response.data.page.body only includes page content, not the whole body
            const fullContent = `
            <section class="section-padding" style="--PT: 50px; --PB: 36px;">
              <div class="wrapper">
                <div class="text__standard text-left">
                  <h1 class="gt-h1">
                    ${page.title}
                  </h1>
                  <div class="rte gt-p">
                    ${page.body}
                  </div>
                </div>
              </div>
            </section>
          `;
            return { title: page.title, content: fullContent };
          }
        } catch (error) {
          console.error('Error fetching page details:', error);
          return null;
        }
      },
      setSizeGuideFloatingContentVisible(shouldShow) {
        document.dispatchEvent(new CustomEvent(shouldShow ? 'chat:show' : 'chat:hide', { bubbles: true }));
      },
      showSizeGuide() {
        const idx = this.outfitPickerIndex && this.isOutfitPicker ? this.outfitPickerIndex : 1;
        const modalId = `sizeGuideModal-${idx}`;
        if (window.MicroModal && typeof window.MicroModal.show === 'function') {
          try {
            window.MicroModal.show(modalId, {
              disableScroll: true,
              onShow: () => this.setSizeGuideFloatingContentVisible(false),
              onClose: () => this.setSizeGuideFloatingContentVisible(true)
            });
            return;
          } catch (e) {
            console.warn('Failed to open size guide modal', e);
          }
        }
        const fallback = document.getElementById(modalId) || document.getElementById('sizeGuideModal-1');
        if (!fallback) return;
        fallback.classList.add('is-open');
        document.documentElement.classList.remove('aos-initialized');
        document.body.classList.add('unscrollable-body');
        this.setSizeGuideFloatingContentVisible(false);
      },
      async getSizeGuideData() {
        let showButton = false;
        try {
          const index = this.outfitPickerIndex && this.isOutfitPicker ? String(this.outfitPickerIndex) : '1';
          const metafields = await this.getMetafields([
            {
              namespace: this.sizeGuideMetafield.split('.')[0],
              key: this.sizeGuideMetafield.split('.')[1]
            }
          ]);
          if (!metafields) return;

          const sizeGuideMetafield = metafields.find(m => m?.key === this.sizeGuideMetafield.split('.')[1]);
          if (!sizeGuideMetafield) {
            return;
          }

          const pageId = sizeGuideMetafield.value.split('/').pop();
          const pageData = await fetchSizeGuidePageContent(pageId);
          if (!pageData) return;
          const sizeGuideContent = document.querySelector(`.size-guide-content-${index}`);
          if (!sizeGuideContent) return;
          sizeGuideContent.innerHTML = pageData.content;
          showButton = true;
        } catch (error) {
          showButton = false;
        }
        this.shouldShowSizeGuideButton(showButton);
      },
      async getHelpGuideData() {
        if (!this.helpGuideMetafield) {
          this.shouldShowHelpGuideButton(false);
          return;
        }
        let showButton = false;
        try {
          const metafields = await this.getMetafields([
            {
              namespace: this.helpGuideMetafield.split('.')[0],
              key: this.helpGuideMetafield.split('.')[1]
            }
          ]);
          if (!metafields) return;

          const helpGuideMetafield = metafields.find(m => m?.key === this.helpGuideMetafield.split('.')[1]);
          if (!helpGuideMetafield) {
            return;
          }

          const pageId = helpGuideMetafield.value.split('/').pop();
          const pageData = await this.getOnlineStorePage(pageId);
          if (!pageData) return;
          const helpGuideContent = document.querySelector('#more-info-modal-content');
          if (helpGuideContent) {
            helpGuideContent.innerHTML = pageData.content;
            document.dispatchEvent(new CustomEvent('theme:accordion:bind', { bubbles: true, detail: { root: helpGuideContent } }));
            this.helpGuidePageTitle = pageData.title;
            showButton = true;
          }
        } catch (error) {
          showButton = false;
        }
        this.shouldShowHelpGuideButton(showButton);
      },
      setDefaultSelections() {
        let effectiveSelectedColor = this.selectedColor;
        let effectiveSelectedWidth = this.selectedWidth;

        if (this.isOutfitPicker) {
          try {
            const selectedColorEl = this.pdpSection?.querySelector('.color-variant-options [data-color].selected');
            const selectedWidthEl = this.pdpSection?.querySelector('.width-variant-options [data-width].selected');
            if (selectedColorEl) {
              effectiveSelectedColor = selectedColorEl.getAttribute('data-color');
            }
            if (selectedWidthEl) {
              const raw = selectedWidthEl.getAttribute('data-width');
              effectiveSelectedWidth = raw.startsWith('w') ? raw.slice(1) : raw;
            }
          } catch (e) {
            console.error('Error getting selected width and color:', e);
          }
          if (!effectiveSelectedColor && this.colors.length) {
            const byHandle = this.product_handle ? this.colors.find(c => c.handle === this.product_handle) : null;
            effectiveSelectedColor = (byHandle && byHandle.name) || this.colors[0].name;
          }
        }

        const potentialVariants = [];
        if (this.isOutfitPicker && this.previouslySelectedSize) potentialVariants.push(this.previouslySelectedSize);
        if (this.passedOptTwo) potentialVariants.push(this.passedOptTwo);
        if (this.userPreferredProductSize) potentialVariants.push(this.userPreferredProductSize);

        // Choose first variant that exists for this product
        let chosen = potentialVariants.find(s => Array.isArray(this.sizes) && this.sizes.includes(s));

        // If no variant is found, pick the first available given color/width
        if (!chosen) {
          chosen = this.findFirstAvailableSize(effectiveSelectedColor, effectiveSelectedWidth);
        }

        // Final fallback: first size in list
        if (!chosen && Array.isArray(this.sizes) && this.sizes.length > 0) {
          chosen = this.sizes[0];
        }

        if (chosen) {
          this.setSizeSelection(chosen);
        }

        this.updateAvailability();
        setTimeout(() => {
          this.positionHelpGuide();
        }, 1000);
      },
      findFirstAvailableSize(effectiveSelectedColor, effectiveSelectedWidth) {
        if (!Array.isArray(this.sizes) || !Array.isArray(this.variants)) return '';
        for (const size of this.sizes) {
          const availableVariant = this.variants.find(v => v && v.size === size && v.availableForSale && (!effectiveSelectedColor || v.color === effectiveSelectedColor) && (!effectiveSelectedWidth || !v.width || v.width === effectiveSelectedWidth));
          if (availableVariant) return size;
        }
        return '';
      },
      getOptionImage(opt, optName) {
        if (opt === 'option2' && this.show_image_2 === 'true') {
          return 'background-image:url(' + window.cdn + handleize(optName) + '.png)';
        }
      },
      positionHelpGuide() {
        // Emit event for ProductFamilyHelper positioning
        emitter.emit('showHelpGuide');
      },
      showHelpGuide() {
        // Open the help guide modal
        const modalId = 'more-info-modal';
        if (window.MicroModal && typeof window.MicroModal.show === 'function') {
          try {
            window.MicroModal.show(modalId, {
              disableScroll: true,
              onShow: () => this.setSizeGuideFloatingContentVisible(false),
              onClose: () => this.setSizeGuideFloatingContentVisible(true)
            });
            return;
          } catch (e) {
            console.warn('Failed to open help guide modal', e);
          }
        }
        const fallback = document.getElementById(modalId);
        if (!fallback) return;
        fallback.classList.add('is-open');
        document.documentElement.classList.remove('aos-initialized');
        document.body.classList.add('unscrollable-body');
        this.setSizeGuideFloatingContentVisible(false);
        if (!fallback.getAttribute('data-help-guide-close-bound')) {
          fallback.setAttribute('data-help-guide-close-bound', 'true');
          const closeBtn = fallback.querySelector('.modal__close');
          if (closeBtn) {
            closeBtn.addEventListener('click', () => {
              fallback.classList.remove('is-open');
              document.documentElement.classList.add('aos-initialized');
              document.body.classList.remove('unscrollable-body');
              this.setSizeGuideFloatingContentVisible(true);
            });
          }
        }
      },
      closeSizeGuideModal() {
        const tryClose = id => {
          const el = document.getElementById(id);
          if (!el || !el.classList.contains('is-open')) return false;
          if (window.MicroModal && typeof window.MicroModal.close === 'function') {
            try {
              window.MicroModal.close(id);
              return true;
            } catch (e) {
              // MicroModal internal error - fall through to manual close
            }
          }
          el.classList.remove('is-open');
          document.documentElement.classList.add('aos-initialized');
          document.body.scrollTop = 0;
          document.body.classList.remove('unscrollable-body');
          this.setSizeGuideFloatingContentVisible(true);
          return true;
        };
        tryClose('sizeGuideModal-1');
        tryClose('sizeGuideModal-2');
      },
      shouldHideSizes() {
        const hideSizes = window.siteGlobals.set_reminder_pdp_hide_sizes === 'true';
        let comingSoon = false;
        if (this.colors && this.selectedColor) {
          const color = this.colors.find(color => color.name === this.selectedColor);
          if (color && color.tags && color.tags.includes(this.comingSoonTag)) {
            comingSoon = true;
            [...this.pdpSection.querySelectorAll(`[data-color='${CSS.escape(this.selectedColor)}']`)].forEach(element => {
              element.classList.remove('unavailable');
              const colorName = element.getAttribute('data-color') || this.selectedColor;
              const sizeContext = this.selectedSize ? ` in size ${this.selectedSize}` : '';
              element.setAttribute('aria-label', `${this.product_title}${sizeContext} color option: ${colorName} is available`);
            });
          }
        }
        return hideSizes && comingSoon;
      },
      resolveOutfitPickerIndex() {
        try {
          const productInner = this.$el.closest('.product__inner');
          const container = this.$el.closest('.op-size-options');
          const siblings = productInner ? Array.from(productInner.querySelectorAll('.op-size-options')) : [];
          const idx0 = siblings.findIndex(el => el === container);
          this.outfitPickerIndex = idx0 >= 0 ? idx0 + 1 : null;
        } catch (e) {
          this.outfitPickerIndex = null;
        }
      },
      handleSlideVariantImage(size) {
        const loggingEnabled = productStore.isLoggingEnabled(document.getElementById('product-families-json-data')?.dataset.speedTracking === 'true');
        if (!this.slideVariantImage) {
          if (loggingEnabled) console.log('[SmartTags][Size] Slide disabled', { productTitle: this.product_title, selectedColor: this.selectedColor, selectedSize: size, selectedWidth: this.selectedWidth });
          return;
        }
        const currentVariant = this.variants.find(variant => variant.color === this.selectedColor && variant.size === size);
        if (currentVariant && currentVariant.image) {
          if (loggingEnabled) console.log('[SmartTags][Size] Emit variant-updated', { productTitle: this.product_title, selectedColor: this.selectedColor, selectedSize: size, image: currentVariant.image });
          this.lastEmittedImage = currentVariant.image;
          setTimeout(() => {
            emitter.emit('variant-updated', {
              image: currentVariant.image,
              width: size
            });
          }, 200);
        } else {
          if (loggingEnabled) console.log('[SmartTags][Size] No variant image match', { productTitle: this.product_title, selectedColor: this.selectedColor, selectedSize: size, hasVariant: !!currentVariant, variantImage: currentVariant?.image || null });
          setTimeout(() => {
            emitter.emit('variant-updated', { resetToFirst: true });
          }, 200);
        }
      },
      isMobile() {
        return window.innerWidth <= window.theme?.sizes.medium;
      },
      updateMobileViewport() {
        this.isMobileViewport = this.isMobile();
      }
    }
  };
</script>

<template>
  <div class="size-variant-option" v-if="!isBundleProduct && (isOutfitPicker || !isLoading) && !shouldHideSizes()">
    <div class="size-variant-options">
      <div class="size-wrapper" v-if="sizes.length">
        <p :class="'option-title' + (mini_pdp ? ' mini-pdp-option-title' : '')">
          <span v-html="optionTwoName" class="option-name gt-p__small"></span>
          <span class="gt-p__small">:&nbsp;</span>
          <span v-html="cleanSizeName(selectedSize)" class="gt-p__small"></span>
        </p>
        <button v-if="ShowHelpGuideButton" id="help-guide-toggle" type="button" class="help-guide-toggle gt-p__small" @click="showHelpGuide()">
          {{ helpGuidePageTitle }}
        </button>
        <button v-if="ShowSizeGuideButton" id="size-guide-toggle" type="button" class="size-guide-toggle gt-p__small" :aria-label="'Size Guide for ' + product_title" @click="showSizeGuide()">Size Guide</button>
      </div>
      <div class="variant-spacing option-size-2 variant-spacing-size">
        <div v-for="(size, index) in sizes" :key="'size' + index" @click="setSizeSelection(size)">
          <button type="button" v-html="cleanSizeName(size)" :class="'option p-options option2' + (mini_pdp ? ' mini-pdp-size-swatches' : '') + (isOutfitPicker && isMobileViewport ? ' gt-p__small' : '')" :data-size="'s' + size"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .size-variant-option {
    width: 100%;

    .size-variant-options {
      .variant-spacing {
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        row-gap: 5px;

        &:has(.mini-pdp-size-swatches) {
          .is-mobile & {
            flex-wrap: nowrap;
            overflow-x: scroll;
            scroll-behavior: smooth;
            margin: 0 var(--outer-offset);
            padding-left: var(--outer);
            padding-right: 0;
            width: calc(100% + var(--outer) * 2 + var(--LAYOUT-GUTTER) / 2);

            > div {
              flex: 0 0 auto;
              overflow: hidden;
              padding: 0.1em;
              &:last-of-type {
                margin-right: var(--gutter);
              }
            }
          }
        }
      }

      .size-wrapper {
        display: flex;
        width: 100%;
        margin-top: 10px;
        align-items: center;
      }
    }

    #help-guide-toggle {
      margin-left: auto;
      width: 100%;
      text-align: right;
      margin-right: 1rem;
    }
  }
</style>
